import { GreenroomSessionMeetingData } from '@/store/slices/project/types';
import { ESpeakerInviteStatus, Speaker } from '@/types/speakers.types';

/* 
  Context note:
  - "presenters" are speakers with admin presenter roles AND Greenroom meeting presenter status (watcher_only: false)
  - "speakers" are speakers without admin presenter roles or Greenroom meeting presenter status (watcher_only: true)
*/
const getCastInviteStatus = ({
  speaker,
  activeChannel,
  sessionMeetingData,
}: {
  speaker: Speaker;
  activeChannel: number | null;
  sessionMeetingData: GreenroomSessionMeetingData | null;
}) => {
  if (!activeChannel) return '';
  const adminProfile = speaker?.bl_admin;
  const hasInvite = sessionMeetingData?.invites?.find(
    (invitee) => invitee.profile?.events_profile === speaker?.bl_admin?.id
  );

  if (!hasInvite) return '';

  if (speaker.invite_status === ESpeakerInviteStatus.confirmed) {
    return 'Accepted';
  }

  if (speaker.invite_status === ESpeakerInviteStatus.pending) {
    return 'Invite sent';
  }

  // fallbacks on profile
  if (adminProfile && !adminProfile.verified) {
    return 'Invite sent';
  }

  if (adminProfile && adminProfile.verified) {
    return 'Accepted';
  }

  return '';
};

export default getCastInviteStatus;
